import { useTranslation } from 'react-i18next';
import { namespaces } from "../i18n/resources";
export const useAppTranslation = () => {
    return useTranslation(namespaces);
};
